import { render, staticRenderFns } from "./mvAuthority.vue?vue&type=template&id=70ae6d0d&scoped=true"
import script from "./mvAuthority.vue?vue&type=script&lang=js"
export * from "./mvAuthority.vue?vue&type=script&lang=js"
import style0 from "./mvAuthority.vue?vue&type=style&index=0&id=70ae6d0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae6d0d",
  null
  
)

export default component.exports